import { graphql, compose } from 'react-apollo';
import { approveFeedPostMutation } from '../../students/graphql/approve-feed-post.mutation';
import { rejectFeedPostMutation } from '../../students/graphql/reject-feed-post.mutation';
import { FeedPostApprovalDialogView } from './feed-post-approval-dialog.component';

const withApproveMutation = graphql(approveFeedPostMutation, {
  options: {
    refetchQueries: ['waitingFeedPostApprovals', 'statistics'],
  },
  props: ({ mutate }) => ({
    approve: (feedItemId) => mutate({ variables: { feedItemId } }),
  }),
});

const withRejectMutation = graphql(rejectFeedPostMutation, {
  options: {
    refetchQueries: ['waitingFeedPostApprovals', 'statistics'],
  },
  props: ({ mutate }) => ({
    reject: (feedItemId, rejectionReason) =>
      mutate({ variables: { rejectionReason, feedItemId } }),
  }),
});

export const FeedPostApprovalDialog = compose(
  withApproveMutation,
  withRejectMutation
)(FeedPostApprovalDialogView);
